import PropTypes from "prop-types";
import React, { useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MenuIcon from "@mui/icons-material/MoreVert";

const useStyles = makeStyles(theme => ({
  menuButton: {
    color: "white",
    opacity: "0.5"
  }
}));

const DashboardWidgetMenu = props => {
  const {
    options,
    onMenuItemClick,
    defaultMenuOptions,
    defaultMenuItemClick
  } = props;
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuItemClick = option => {
    defaultMenuItemClick(option);
    onMenuItemClick(option);
  };

  return (
    <>
      <IconButton
        data-qa="dashboard-widget-menu-button"
        className={classes.menuButton}
        onClick={ev => {
          setAnchorEl(ev.currentTarget);
        }}
        size="large"
      >
        <MenuIcon />
      </IconButton>
      <Menu
        data-qa="dashboard-widget-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => {
          setAnchorEl(null);
        }}
      >
        {[...defaultMenuOptions, ...options].map(option => (
          <MenuItem
            key={option.value}
            onClick={() => {
              handleMenuItemClick(option);
              setAnchorEl(null);
            }}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default DashboardWidgetMenu;

DashboardWidgetMenu.propTypes = {
  options: PropTypes.array,
  onMenuItemClick: PropTypes.func,
  defaultMenuOptions: PropTypes.array,
  defaultMenuItemClick: PropTypes.func
};
